<template>
  <div class="china-list">
    <div class="filter-bar">
      <div class="filter-item">
        <span class="label">状态：</span>
        <el-dropdown @command="handleStateCommand" trigger="click">
          <span class="el-dropdown-link">
            {{ stateName }}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="99">全部</el-dropdown-item>
            <el-dropdown-item command="0">草稿</el-dropdown-item>
            <el-dropdown-item command="1">已收费</el-dropdown-item>
            <el-dropdown-item command="3">已发药</el-dropdown-item>
            <el-dropdown-item command="4">已退药</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="filter-item">
        <span class="label">科室：</span>
        <el-select v-model="queryForm.bilgDeptId" placeholder="请选择科室" clearable size="small" style="width: 130px;" @change="loadData">
          <el-option v-for="d in deptOptions" :key="d.id" :label="d.label" :value="d.id"></el-option>
        </el-select>
      </div>
      <div class="filter-item">
        <span class="label">医生：</span>
        <el-select v-model="queryForm.bilgDrId" placeholder="请选择医生" clearable size="small" style="width: 120px;" @change="loadData">
          <el-option v-for="d in doctorOptions" :key="d.id" :label="d.label" :value="d.id"></el-option>
        </el-select>
      </div>
      <div class="filter-item">
        <span class="label">病人名称：</span>
        <el-input v-model="queryForm.name" placeholder="请输入病人名称" size="small" style="width: 130px;" clearable @keyup.enter.native="loadData"></el-input>
      </div>
      <div class="filter-item">
        <span class="label">收费时间：</span>
        <el-date-picker
            v-model="queryForm.timeRange"
            type="datetimerange"
            size="small"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            @change="loadData"
        />
      </div>
      <div class="filter-item">
        <span class="label">发药时间：</span>
        <el-date-picker
            v-model="queryForm.sendTimeRange"
            type="datetimerange"
            size="small"
            range-separator="至"
            start-placeholder="发药开始"
            end-placeholder="发药结束"
            :picker-options="pickerOptions"
            @change="loadData"
        />
      </div>
    </div>

    <div class="table">
      <el-table
          :data="tableData"
          border
          :summary-method="getSummaries"
          @row-dblclick="showDrugDetails"
          show-summary
      >
        <el-table-column
            v-for="col in tableRows"
            :key="col.prop"
            :prop="col.prop"
            :label="col.name"
            align="center"
            :min-width="getColumnWidth(col.label, col.prop, tableData)"
        >
          <template #default="{ row }">
            {{ safeGetMappedValue(col, row) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120" fixed="right">
          <template #default="{ row }">
            <el-button size="mini" type="primary" @click="showDrugDetails(row)">查看药品</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-pagination
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-sizes="[8, 16, 24]"
        :page-size="pageSize"
        :total="totalSize"
        layout="total, sizes, prev, pager, next, jumper"
        background
    />

    <!-- 完整药品详情弹窗 -->
    <el-dialog title="药品详情" :visible.sync="showDrugModal" width="700px" top="5vh">
      <template v-if="chinaDetail.length > 0">
        <div class="drug-nav">
          <el-button
              v-for="(drug, index) in chinaDetail"
              :key="index"
              size="mini"
              :type="currentIndex === index ? 'primary' : ''"
              @click="switchDrug(index)"
          >
            {{ index + 1 }}. {{ drug.drugName }}
          </el-button>
        </div>
        <div class="drug-content">
          <el-descriptions :column="2" border size="small">
            <el-descriptions-item label="药品名称">{{ currentDrug.drugName }}</el-descriptions-item>
            <el-descriptions-item label="药品ID">{{ currentDrug.drugId }}</el-descriptions-item>
            <el-descriptions-item label="医保编码">{{ currentDrug.chsCode || '无' }}</el-descriptions-item>
            <el-descriptions-item label="医保名称">{{ currentDrug.chsName || '无' }}</el-descriptions-item>
            <el-descriptions-item label="生产厂家ID">{{ currentDrug.prodentpId }}</el-descriptions-item>
            <el-descriptions-item label="单位">{{ getDrugUnt(currentDrug.unt) }}</el-descriptions-item>
          </el-descriptions>

          <el-descriptions :column="2" border size="small" class="mt-10">
            <el-descriptions-item label="数量">{{ currentDrug.cnt }}</el-descriptions-item>
            <el-descriptions-item label="销售单价">¥{{ currentDrug.salePric }}</el-descriptions-item>
            <el-descriptions-item label="成本单价">¥{{ currentDrug.purcPric }}</el-descriptions-item>
            <el-descriptions-item label="小单位零售单价">¥{{ currentDrug.minPurcPric }}</el-descriptions-item>
            <el-descriptions-item label="销售金额">¥{{ currentDrug.saleAmt }}</el-descriptions-item>
            <el-descriptions-item label="成本金额">¥{{ currentDrug.purcAmt }}</el-descriptions-item>
            <el-descriptions-item label="退货数量">{{ currentDrug.retnCnt }}</el-descriptions-item>
            <el-descriptions-item label="退货金额">¥{{ currentDrug.retnAmt }}</el-descriptions-item>
          </el-descriptions>

          <el-descriptions :column="2" border size="small" class="mt-10">
            <el-descriptions-item label="给药方式">{{ getChinaMedicationWayLabel(currentDrug.medcWayId) }}</el-descriptions-item>
            <el-descriptions-item label="用药频率">{{ getChinaMedicationFrequency(currentDrug.usedfrquId) }}</el-descriptions-item>
            <el-descriptions-item label="单次剂量">{{ currentDrug.sdoseCnt }}{{ currentDrug.sdoseUnt }}</el-descriptions-item>
            <el-descriptions-item label="总剂量">{{ currentDrug.sdoseSum }}</el-descriptions-item>
            <el-descriptions-item label="销售单位">
              {{ currentDrug.saleUnt === 1 ? '最小单位' : '包装单位' }}
            </el-descriptions-item>
            <el-descriptions-item label="取整方式">{{ getRoundUntText(currentDrug.roundUnt) }}</el-descriptions-item>
          </el-descriptions>

          <el-descriptions :column="2" border size="small" class="mt-10">
            <el-descriptions-item label="中药付数">{{ currentDrug.tcmCnt }}</el-descriptions-item>
            <el-descriptions-item label="退药中药付数">{{ currentDrug.renTcmCnt }}</el-descriptions-item>
            <el-descriptions-item label="中药角注">{{ getChinaMakeLabel(currentDrug.methodId) || '无' }}</el-descriptions-item>
            <el-descriptions-item label="中药角注ID">{{ currentDrug.methodId }}</el-descriptions-item>
            <el-descriptions-item label="周期天数">{{ currentDrug.prdDays }}</el-descriptions-item>
            <el-descriptions-item label="周期次数">{{ currentDrug.prdCnt }}</el-descriptions-item>
          </el-descriptions>

          <el-descriptions :column="2" border size="small" class="mt-10">
            <el-descriptions-item label="有效期">{{ currentDrug.expyDate || '无' }}</el-descriptions-item>
            <el-descriptions-item label="追溯码">{{ currentDrug.tracecode || '无' }}</el-descriptions-item>
            <el-descriptions-item label="处方单据ID">{{ currentDrug.rxId }}</el-descriptions-item>
            <el-descriptions-item label="备注">{{ currentDrug.remarks || '无' }}</el-descriptions-item>
          </el-descriptions>
        </div>
      </template>
      <div v-else class="empty-data">暂无药品数据</div>
      <div slot="footer" class="dialog-footer">
        <el-button-group>
          <el-button size="small" :disabled="currentIndex <= 0" @click="switchDrug(currentIndex - 1)">上一个</el-button>
          <el-button size="small" :disabled="currentIndex >= chinaDetail.length - 1" @click="switchDrug(currentIndex + 1)">下一个</el-button>
        </el-button-group>
        <el-button size="small" @click="showDrugModal = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getChinaMedicineListPage } from "@/api/chinaMedicineList/chinaMedicineList";
import { getChinaPrescription } from "@/api/reservation/outpatientPhysician";
import dayjs from "dayjs";
import { getAllDept, getDoctorList, dict } from "@/api/reservation/reservationList";

export default {
  name: "ChinaPrescription",
  data() {
    return {
      pageNum: 1,
      pageSize: 8,
      totalSize: 0,
      tableData: [],
      showDrugModal: false,
      chinaDetail: [],
      currentIndex: 0,
      queryForm: {
        bilgDeptId: null,
        bilgDrId: null,
        name: '',
        timeRange: [
          dayjs().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
          dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss')
        ],
        sendTimeRange: null,
        state: null,
      },
      stateName: '全部',
      deptOptions: [],
      doctorOptions: [],
      chinaMedicationWayOptions: [],
      medicationFrequencyOptions: [],
      drugUntListOption: [],
      chinaMakeOptions: [],
      pickerOptions: {
        shortcuts: [
          { text: '最近一周', onClick(picker) { const end = new Date(); const start = new Date(); start.setTime(start.getTime() - 3600 * 1000 * 24 * 7); picker.$emit('pick', [start, end]); } },
          { text: '最近一个月', onClick(picker) { const end = new Date(); const start = new Date(); start.setTime(start.getTime() - 3600 * 1000 * 24 * 30); picker.$emit('pick', [start, end]); } },
          { text: '最近三个月', onClick(picker) { const end = new Date(); const start = new Date(); start.setTime(start.getTime() - 3600 * 1000 * 24 * 90); picker.$emit('pick', [start, end]); } }
        ]
      },
      tableRows: [
        { name: "处方序号", prop: "rxNo" },
        { name: "病人姓名", prop: "name" },
        { name: "性别", prop: "sex", op: 'sexOptions' },
        { name: "年龄", prop: "age" },
        { name: "状态", prop: "state", op: 'stateOptions' },
        { name: "合计金额", prop: "saleAmt" },
        { name: "退药金额", prop: "reAmt" },
        { name: "处方科室", prop: "bilgDeptName" },
        { name: "处方医生", prop: "bilgDrName" },
        { name: "划价人", prop: "bilgOptName" },
        { name: "发药人", prop: "dismedOptName" },
        { name: "药房名称", prop: "phayId", op: 'phayIdOptions' },
        { name: "用法", prop: "tcmWayName" },
        { name: "频率", prop: "usedFrquName" },
        { name: "方式", prop: "medcWayName" },
        { name: "付数", prop: "tcmCnt" },
        { name: "划价方式", prop: "pricingType", op: 'pricingTypeOptions' },
        { name: "处方类型", prop: "rxName" },
        { name: "处方编号", prop: "rxNo" },
        { name: "收费时间", prop: "costDate" },
        { name: "发药时间", prop: "dismedOptDate" }
      ],
      sexOptions: [{ id: 1, label: '男' }, { id: 2, label: '女' }],
      stateOptions: [
        { id: 0, label: '草稿' }, { id: 1, label: '已收费' },
        { id: 3, label: '已发药' }, { id: 4, label: '已退药' }
      ],
      phayIdOptions: [{ id: 1, label: '西药房' }, { id: 2, label: '中药房' }],
      pricingTypeOptions: [
        { id: 1, label: '医嘱划价' }, { id: 2, label: '手工划价' }, { id: 3, label: '互联网划价' }
      ]
    };
  },
  computed: {
    currentDrug() {
      return this.chinaDetail[this.currentIndex] || {};
    }
  },
  mounted() {
    this.loadOptions();
    this.loadData();
  },
  methods: {
    async loadOptions() {
      this.doctorOptions = this.$store.getters['preload/getDoctorListOptions'] || [];
      this.deptOptions = this.$store.getters['preload/getAttributeListOptions'] || [];
      this.medicationFrequencyOptions = this.$store.getters['preload/getMedicationWayListOptions'] || [];
      this.drugUntListOption = this.$store.getters['preload/getDrugUntListOption'] || [];

      if (!this.deptOptions.length) {
        const deptRes = await getAllDept();
        if (deptRes.code === 200) this.deptOptions = deptRes.data.map(item => ({ id: item.id, label: item.deptName }));
      }
      if (!this.doctorOptions.length) {
        const doctorRes = await getDoctorList();
        if (doctorRes.code === 200) this.doctorOptions = doctorRes.data.map(item => ({ id: item.id, label: item.fullName }));
      }

      try {
        const res = await dict();
        this.chinaMedicationWayOptions = (res.data.ruteVo || [])
            .filter(item => item.lmtSpc === 2)
            .map(item => ({ id: item.id, label: item.name }));
      } catch (error) {
        console.error('获取给药方式失败:', error);
        this.chinaMedicationWayOptions = [];
      }

      if (!this.$store.state.dict || Object.keys(this.$store.state.dict).length === 0) {
        await this.$store.dispatch('fetchDictData');
        this.chinaMakeOptions = this.$store.state.dict.methodTypeVO;
      } else {
        this.chinaMakeOptions = this.$store.state.dict.methodTypeVO;
      }
    },
    getChinaMedicationFrequency(id) {
      if (!id) return '未知';
      const way = this.medicationFrequencyOptions.find(item => item.id === id);
      return way ? way.label : `未知(${id})`;
    },
    getDrugUnt(id) {
      if (!id) return '未知';
      const way = this.drugUntListOption.find(item => item.id === parseInt(id));
      return way ? way.label : `未知(${id})`;
    },
    getChinaMedicationWayLabel(id) {
      if (!id) return '未知';
      const way = this.chinaMedicationWayOptions.find(item => item.id === id);
      return way ? way.label : `未知(${id})`;
    },
    getChinaMakeLabel(id) {
      if (!id) return '未知';
      const way = this.chinaMakeOptions.find(item => item.id === id);
      return way ? way.name : `未知(${id})`;
    },
    getRoundUntText(roundUnt) {
      const map = { 1: '单次取整', 2: '总量取整', 3: '处方取整', 4: '不取整' };
      return map[roundUnt] || '未知';
    },
    async showDrugDetails(row) {
      const res = await getChinaPrescription({ id: row.id });
      this.chinaDetail = res.data.tcmDetailsRespVOS;
      this.currentIndex = 0;
      this.showDrugModal = true;
    },
    switchDrug(index) {
      if (index >= 0 && index < this.chinaDetail.length) this.currentIndex = index;
    },
    handleStateCommand(command) {
      const stateMap = { '0': '草稿', '1': '已收费', '3': '已发药', '4': '已退药', '99': '全部' };
      this.stateName = stateMap[command] || '全部';
      this.queryForm.state = command === '99' ? null : parseInt(command);
      this.loadData();
    },
    async loadData() {
      try {
        const params = {
          pageSize: this.pageSize,
          pageNum: this.pageNum,
          bilgDeptId: this.queryForm.bilgDeptId || null,
          bilgDrId: this.queryForm.bilgDrId || null,
          name: this.queryForm.name || '',
          startTime: this.queryForm.timeRange?.[0] || '',
          endTime: this.queryForm.timeRange?.[1] || '',
          sendStartTime: this.queryForm.sendTimeRange?.[0] || '',
          sendEndTime: this.queryForm.sendTimeRange?.[1] || '',
          state: this.queryForm.state ?? null
        };
        const res = await getChinaMedicineListPage(params);
        if (res.code === 200) {
          this.totalSize = res.data.totalSize;
          this.tableData = res.data.content;
        } else {
          this.$message.error("系统异常:请联系管理员");
        }
      } catch (error) {
        this.$message.error("系统异常:请联系管理员");
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageNum = 1;
      this.loadData();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.loadData();
    },
    getColumnWidth(label, prop, tableData) {
      const minWidth = 100;
      const padding = 30;
      const contentList = tableData.map(item => item?.[prop] ?? '');
      const widths = [...contentList, label].map(text => {
        const str = String(text || '');
        return this.getTextWidth(str) + padding;
      });
      return Math.max(minWidth, ...widths);
    },
    getTextWidth(text, fontSize = 14) {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      ctx.font = `${fontSize}px Microsoft YaHei`;
      return ctx.measureText(text).width;
    },
    safeGetMappedValue(col, row) {
      const hiddenProps = new Set([
        'usedfrquId', 'sdoseCnt', 'prdCnt', 'prdDays', 'medcWayId', 'tcmCnt',
        'selfProe', 'skintstRslt', 'remark', 'remarks', 'rxDosCnt'
      ]);
      if (hiddenProps.has(col.prop)) return '';
      const rawValue = row[col.prop];
      if (rawValue === null || rawValue === undefined) return ' ';
      const mapArray = this[col.op];
      if (!col.op || !Array.isArray(mapArray)) return rawValue;
      const matched = mapArray.find(item => item.id == rawValue);
      return matched?.label || rawValue;
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      const calcFields = { 'saleAmt': '合计金额', 'reAmt': '退药金额' };
      columns.forEach((column, index) => {
        if (index === 0) sums[index] = '';
        else if (index === 1) sums[index] = '合计';
        else if (calcFields[column.property]) {
          const total = data.reduce((sum, item) => sum + (parseFloat(item[column.property]) || 0), 0);
          sums[index] = total.toFixed(2);
        } else sums[index] = '';
      });
      return sums;
    }
  }
};
</script>

<style lang="less" scoped>
.china-list {
  height: 100%;
  display: flex;
  flex-direction: column;
  .filter-bar {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 16px;
    margin-bottom: 16px;
    padding: 12px;
    border-radius: 4px;
    flex-shrink: 0;
  }
  .filter-item {
    display: flex;
    align-items: center;
    gap: 6px;
    .label {
      font-size: 12px;
      color: #606266;
      font-weight: bold;
    }
  }
  .el-dropdown-link {
    cursor: pointer;
    font-size: 12px;
    color: #606266;
    padding: 0 8px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    line-height: 28px;
    display: inline-block;
    background: #fff;
  }
  .table {
    flex: 1;
    overflow-x: auto;
  }
  .pagination {
    margin-top: 16px;
    text-align: center;
    flex-shrink: 0;
  }
  .drug-nav {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
    margin-bottom: 15px;
    max-height: 120px;
    overflow-y: auto;
  }
  .drug-content {
    padding: 0 10px;
  }
  .mt-10 {
    margin-top: 10px;
  }
  .dialog-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  /deep/ .el-dialog__header {
    padding: 18px;
    background-color: #007bb0;
  }
  /deep/ .el-dialog__title {
    font-size: 18px;
    color: #fff;
  }
  /deep/ .el-dialog__headerbtn .el-dialog__close {
    color: #fff;
  }
}
</style>